module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Wood1-11b9ad6553af7cce24dae37c7bc7bf51.svg";